import { render, staticRenderFns } from "./_id.vue?vue&type=template&id=48c13754"
import script from "./_id.vue?vue&type=script&lang=js"
export * from "./_id.vue?vue&type=script&lang=js"
import style0 from "~/assets/css/eashop/details.scss?vue&type=style&index=0&prod&lang=scss&external"
import style1 from "~/assets/arabCSS/eashop/details.scss?vue&type=style&index=1&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports